import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'

export const serviceCategoryTypeEnums = [
   'Business Development',
   'Compliance',
   'Compliance Plus',
   'Bookkeeping',
   'Advisory',
   'Software and Subscriptions'
] as const

export const ServiceCategoryTypeEnumSchema = z.enum(serviceCategoryTypeEnums, { errorMap })
export type ServiceCategoryTypeEnum = z.output<typeof ServiceCategoryTypeEnumSchema>